import { createDeletablePermission } from "@/permissions/shared/createDeletablePermission";
import { useNewsStore } from "@/stores/newsStore";

export function useNewsPermissions() {
  const store = useNewsStore();

  const deletable = createDeletablePermission(store);

  return { deletable };
}
